import { Link } from "react-router-dom";
import { PageHero } from "../components/PageShell";
import { ROUTES } from "../lib/routes";
import { CLUBS } from "../lib/clubs";

export default function Clubs() {
  return (
    <>
      <PageHero
        variant="hero-photo"
        eyebrow="Student life"
        title="Twelve forums. One workshop. Find your people."
        lead="Every student joins at least one forum in their first year — IEEE chapters for the technically minded, EDC for the founders, Quill for the writers, NCC for the disciplined, NSS for the rural-outreach crowd. Every club has a faculty advisor and a real budget."
        crumbs={[{ label: "Campus Life", to: ROUTES.campusLife }, { label: "Clubs & Forums" }]}
        image={null}
      />
      <section className="section">
        <div className="container">
          <div className="kicker">All forums</div>
          <h2 style={{ marginTop: 8, fontSize: "clamp(28px, 3vw, 40px)", fontWeight: 600 }}>Where to start.</h2>
          <div className="club-grid">
            {CLUBS.map((c) => (
              <Link key={c.slug} to={`${ROUTES.clubs}/${c.slug}`} className="club-card reveal">
                <div className="top">
                  <div className="cat">{c.cat}</div>
                  <h3>{c.name}</h3>
                  <div className="since">{c.since}</div>
                </div>
                <div className="body">
                  <p>{c.body}</p>
                  <div className="lead-row">
                    <span className="lbl">Faculty advisor / Strength</span>
                    <span className="name">{c.lead}</span>
                    <span className="members">{c.members}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="report-card" style={{ marginTop: 80 }}>
            <div>
              <h3>Want to start a new forum?</h3>
              <p>Three signed students and one faculty advisor is all it takes. The Dean of Student Affairs reviews proposals at the start of each semester. Approved clubs get a small annual budget and a slot in the orientation week sign-up fair.</p>
            </div>
            <div className="actions">
              <span className="hot">DEAN · STUDENT AFFAIRS</span>
              <span className="num">+91 8192 233 805</span>
              <a className="btn-link" href="mailto:dsa@bietdvg.edu" style={{color: "var(--gold-400)", borderBottomColor: "var(--gold-400)"}}>dsa@bietdvg.edu →</a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
